import { useSelector } from "react-redux"

import { CreationChannel } from "./types"
import { SUPPORTED_CONNECTION_TYPES } from "./values"

interface RootState {
  account: { data: { channels?: CreationChannel[] } }
}

export const isSupportedChannel = (channel: CreationChannel): boolean =>
  SUPPORTED_CONNECTION_TYPES.includes(`${channel.service}_${channel.serviceType}`)

// The channels Create can generate for. Deliberately not filtered on connectionStatus: a batch
// can be created now and its channel reconnected later, and reconnecting keeps the channel id.
export const useSupportedChannels = (): CreationChannel[] => {
  const accountChannels = useSelector((state: RootState) => state.account.data.channels ?? [])
  return accountChannels.filter(isSupportedChannel)
}
